import React, { useEffect } from "react";

import { motion, useAnimation } from "framer-motion";

import { useInView } from "react-intersection-observer";


// ----------------------------------------------------------------------

const AnimateDiv = ({ children, className, variants, transition, threshold, ...other }) => {




    const controls = useAnimation();

    const [ref, inView] = useInView({
        threshold,
        triggerOnce: true
    });

    
    const initialObject = Object.values(variants)[0]
    const animateObject = Object.values(variants)[1]

    useEffect(() => {

        if(inView){
            controls.start(animateObject);
        } else {
            controls.start(initialObject);
        }
    }, [animateObject, controls, inView, initialObject]);

    

    return (

        <motion.div

            ref={ref}
            animate={controls}
            initial={initialObject}
            variants={variants}
            transition={transition}
            className={className}
            {...other}
        >
            {children}

        </motion.div>
        
    );
}

export default AnimateDiv;
